
import html from '../assets/html.png'
import css from '../assets/css.png'
import javascript from '../assets/javascript.png'
import github from '../assets/github.png'
import tailwind from '../assets/tailwind.png'
import react from '../assets/react.png'
import node from '../assets/node.png'
import go from '../assets/go.png'
// import cpp from '../assets/cpp.png'
import python from '../assets/python.png'
import java from '../assets/java.png'
// import laravel from '../assets/laravel.png'
import mysql from '../assets/mysql.png'
import mongo from '../assets/mongo.png'
// import bootstrap from '../assets/bootstrap.png'
import c from '../assets/c.png'
import excel from "../assets/excel.png"
import powerBi from "../assets/powerBi.jpg"
// import vscode from "../assets/vscode.jpg"
import intellij from "../assets/intellij.jpg"

import NextJs from "../assets/NextJs.png"

export const styleForProgramming = "shadow-red-400"
export const programming_icons = [
    // { id: 1, src: cpp, title: "C++", style: styleForProgramming },
    { id: 2, src: java, title: "Java", style: styleForProgramming },
    { id: 3, src: python, title: "Python", style: styleForProgramming },
    { id: 4, src: c, title: "C", style: styleForProgramming },
    { id: 5, src: go, title: "GO", style: styleForProgramming },
];

export const styleForDevelopment = "shadow-blue-400"
export const development_icons = [
    { id: 6, src: react, title: "React", style: styleForDevelopment },
    { id: 8, src: NextJs, title: "NextJs", style: styleForDevelopment },
    { id: 1, src: html, title: "HTML", style: styleForDevelopment },
    { id: 2, src: css, title: "CSS", style: styleForDevelopment },
    { id: 3, src: javascript, title: "JavaScript", style: styleForDevelopment },
    { id: 4, src: github, title: "GitHub", style: styleForDevelopment },
    { id: 5, src: tailwind, title: "Tailwind CSS", style: styleForDevelopment },
    { id: 7, src: node, title: "Node.js", style: styleForDevelopment },
    // { id: 8, src: laravel, title: "Laravel", style: styleForDevelopment },
    // { id: 9, src: bootstrap, title: "Bootstrap", style: styleForDevelopment },
];

export const styleForDatabase = "shadow-green-400"
export const database_icons = [
    { id: 1, src: mysql, title: "MySQL", style: styleForDatabase },
    { id: 2, src: mongo, title: "MongoDB", style: styleForDatabase },
];

export const styleForTools = "shadow-white"
export const tools_icons = [
    // { id: 1, src: vscode, title: "VS Code", style: styleForTools },
    { id: 2, src: intellij, title: "IntelliJ", style: styleForTools },
    { id: 3, src: excel, title: "MS Excel", style: styleForTools },
    { id: 4, src: powerBi, title: "Power Bi", style: styleForTools },
];